(function () {
  function formatRemaining(totalSeconds) {
    if (totalSeconds < 0) totalSeconds = 0;
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    return hours + 'h ' + minutes + 'm';
  }

  function render(el) {
    var remaining = parseInt(el.getAttribute('data-remaining-seconds'), 10);
    if (isNaN(remaining)) return;
    var countdownEl = el.querySelector('[data-jv-delivery-countdown]');
    if (countdownEl) countdownEl.textContent = formatRemaining(remaining);
  }

  function tick(el) {
    var remaining = parseInt(el.getAttribute('data-remaining-seconds'), 10);
    if (isNaN(remaining)) return;
    el.setAttribute('data-remaining-seconds', remaining - 60);
    render(el);
  }

  function init() {
    document.querySelectorAll('[data-jv-delivery-estimate]').forEach(function (el) {
      if (el.dataset.jvDeliveryInitialized) return;
      el.dataset.jvDeliveryInitialized = 'true';
      render(el);
      setInterval(function () {
        tick(el);
      }, 60000);
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  // Cart drawer content is re-fetched via the Section Rendering API on
  // every add/update, replacing the DOM node -- re-scan after that happens.
  var observer = new MutationObserver(function () {
    init();
  });
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
  });
})();
